<template>
	<div>
		<v-container style="max-width:1024px">
			<div style="padding-top:8px" class="content elevation-2">
				<h1>{{ this.lng.articlesHeading }}</h1>
				
				<div v-if="language === 'en'">
					<v-container>
						<p>We do currently not have any articles written in English.</p>
					</v-container>
				</div>
				
				<div v-if="language === 'de'">
					<v-container>
						<a href="/static/articles/Sparen_LG_DE.pdf" target="_blank">
							<div class="tile noselect">
								<picture>
									<source srcset="/static/img/article-icons/Sparen-LG.webp" type="image/webp" />
									<img class="haqcs-height elevation-1" src="/static/img/article-icons/Sparen-LG.png" />
								</picture>
								<div class="text-container_">
									<div class="text">
										<div class="device-title">Sparen Lüftungsgeräte wirklich Energie?</div>
										<p>Natürlich! Aber nicht immer so, wie der Benutzer denkt. Es hängt sehr viel davon ab, wie bewusst er die Lüftungsgeräte einsetzt.</p>
										<p>Wenn die Luft im Raum beheizt ist (und desto mehr, wenn gekühlt werden muss), geht beim Lüften Energie verloren. Aber es muss gelüftet werden. Deswegen sind ...</p>
										<p class="article-date">31. März 2022</p>
									</div>
								</div>
								<div class="icon-container_">
									<div class="icon">
										<v-icon>open_in_new</v-icon>
									</div>
								</div>
							</div>
						</a>
					</v-container>
				</div>
				
				<div v-if="language === 'pl'">
					<v-container>
						<a href="/static/articles/Sparen_LG_PL.pdf" target="_blank">
							<div class="tile noselect">
								<picture>
									<source srcset="/static/img/article-icons/Sparen-LG.webp" type="image/webp" />
									<img class="haqcs-height elevation-1" src="/static/img/article-icons/Sparen-LG.png" />
								</picture>
								<div class="text-container_">
									<div class="text">
										<div class="device-title">Czy rekuperatory oszczędzają rzeczywiście ciepło?</div>
										<p>Oczywiście! Ale nie zawsze w taki sposób, jak myśli użytkownik. Wiele zależy od tego, jak świadomie korzysta on z urządzeń wentylacyjnych.</p>
										<p>Jeśli powietrze w pomieszczeniu jest ogrzewane (a tym bardziej, jeśli wymaga schłodzenia), traci się energię podczas wentylacji. Ale wentylacja jest konieczna. Dlatego pojawiły się ...</p>
										<p class="article-date">31 marca 2022</p>
									</div>
								</div>
								<div class="icon-container_">
									<div class="icon">
										<v-icon>open_in_new</v-icon>
									</div>
								</div>
							</div>
						</a>
					</v-container>
				</div>
				
				<div style="height:64px" />
				
				<h1>{{ this.lng.manualsHeading }}</h1>
				<div v-if="language === 'en'">
					<v-container>
						<router-link to="docs/haqcs" tag="div">
							<div class="tile noselect">
								<picture>
									<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
									<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
								</picture>
								<div class="text-container_">
									<div class="text">
										<div class="device-title">Manual for the HAQCS-Monitor</div>
										<p> Air quality monitor and controller for decentralized ventilation and humidification. </p>
									</div>
								</div>
								<div class="icon-container_">
									<div class="icon">
										<v-icon>chevron_right</v-icon>
									</div>
								</div>
							</div>
						</router-link>
					</v-container>
				</div>
				
				<div v-if="language === 'de'">
					<v-container>
						<router-link to="dokumentation/haqcs" tag="div">
							<div class="tile noselect">
								<picture>
									<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
									<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
								</picture>
								<div class="text-container_">
									<div class="text">
										<div class="device-title">Anleitung für den HAQCS-Monitor</div>
										<p>Luftqualitäts-Monitor und intelligente Lüftungssteuerung in einem Gerät. Seine Sensoren erfassen CO<sub>2</sub>, VOC und Klimawerte. Er zeigt die Luftqualität an, alarmiert und regelt bedarfsgerecht die dezentrale Lüftung.</p>
									</div>
								</div>
								<div class="icon-container_">
									<div class="icon">
										<v-icon>chevron_right</v-icon>
									</div>
								</div>
							</div>
						</router-link>
					</v-container>
				</div>
				
				<div v-if="language === 'pl'">
					<v-container>
						<router-link to="dokumentacja/haqcs" tag="div">
							<div class="tile noselect">
								<picture>
									<source srcset="/static/img/offer/haqcs.webp" type="image/webp" />
									<img class="haqcs-height no-shadow" src="/static/img/offer/haqcs.png" />
								</picture>
								<div class="text-container_">
									<div class="text">
										<div class="device-title">Instrukcja dla HAQCS-Monitora</div>
										<p>Monitor jekości powietrza i automatyczny sterownik wentylacji i nawilżania.</p>
									</div>
								</div>
								<div class="icon-container_">
									<div class="icon">
										<v-icon>chevron_right</v-icon>
									</div>
								</div>
							</div>
						</router-link>
					</v-container>
				</div>
			</div>
		</v-container>
		<div style="height:50vh" />
	</div>
</template>

<script>
export default {
	name: 'Dokumentation',
	mounted: function() {
		this.unwatchLanguage = this.$watch('language', () => { this.updateLng(); });
	},
	beforeDestroy() {
		this.unwatchLanguage();
	},
	data () {
		return {
			headings: [],
			// headingsLng: '',
			scrollTo: function(element) {
				let options = {
					// container: 'body',
					container: '#frame',
					easing: 'ease',
					offset: -64,
					force: true,
					cancelable: false,
					onStart: false,
					onDone: false,
					onCancel: false,
					x: true,
					y: true
				};

				let duration = 700;

				this.$scrollTo(element, duration, options);
			},


			// language
			updateLng: function() {
			    this.lng = this.messages[this.language];
			},
			updateLngLastLng: '',
			lng: {},
			messages: {
			    en: {
					title: 'Documentation',
			        description: 'Documentation of the HAQCS-Monitor, a digital device that measures the air quality and indoor climate of a room and optionally controls up to 16 ventilation units and humidifiers over an ad-hoc wireless network.',
					articlesHeading: 'Articles',
					manualsHeading: 'Manuals',
			    },
			    de: {
					title: 'Dokumentation',
			        description: 'Dokumentation des HAQCS-Monitors, eines digitalen Geräts, das die Luftqualität und das Raumklima eines Raums misst und optional bis zu 16 Lüftungsgeräte und Luftbefeuchter über ein drahtloses Ad-hoc-Netzwerk steuert.',
					articlesHeading: 'Artikel',
					manualsHeading: 'Anleitungen',
				},
				pl: {
					title: 'Dokumentacja',
					description: 'Dokumentacja monitora HAQCS, cyfrowego urządzenia, które mierzy jakość powietrza i klimat wewnętrzny w pomieszczeniu i opcjonalnie kontroluje do 16 jednostek wentylacyjnych i nawilżaczy za pośrednictwem bezprzewodowej sieci ad-hoc.',
					articlesHeading: 'Artykuły',
					manualsHeading: 'Instrukcje',
				}
			},
			getTitle: function() {
				if (this.lng.title === undefined) {
					this.updateLng();
				}
				
				return this.lng.title;
			},
			getMetaDescription: function() {
				if (this.lng.description === undefined) {
					this.updateLng();
				}

				return this.lng.description;
			},
		}
	},
	props: [ 'language' ],
	metaInfo() {
		return {
			title: this.getTitle(),
			// title: "Dokumentation",
			titleTemplate: '%s | Haplabit',
			htmlAttrs: {
			    lang: this.language,
			},
			meta: [
			    { name: 'description', content: this.getMetaDescription() },
			    { name: 'theme-color', content: '#00c853' }
			]
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.content {
	background-color: white;
	padding: 8px;
}

h1 {
	color: black;
	font-size: 2.2rem;
	font-weight: bold;
	font-family: Arial, Helvetica, sans-serif;
	margin-top: 8px;
	/* margin-bottom: -32px; */
	padding-left: 128px;
	padding-right: 128px;
	text-align: center;
}

a {
	text-decoration: none;
	color: black;
}

.back-button {
	position: absolute;
}

@media screen and (max-width: 599px) {
	h1 {
		padding-left: 4px;
		padding-right: 4px;
	}

	.back-button {
		position: relative;
	}
}

h2 {
	padding-top: 48px;
	margin-bottom: 8px;
	color: black;
	/* font-size: 2rem; */
	font-size: 1.2rem;
	/* font-weight: 100; */
	font-weight: 700;
	font-family: Arial, Helvetica, sans-serif;
}

h3 {
	padding-top: 32px;
	margin-bottom: 4px;
	color: black;
	font-size: 1.8rem;
	font-weight: 100;
	font-family: Arial, Helvetica, sans-serif;
}

h4 {
	padding-top: 24px;
	margin-bottom: 2px;
	color: black;
	font-size: 1.5rem;
	font-weight: 100;
	font-family: Arial, Helvetica, sans-serif;
}

.tile {
	display: flex;
	/* justify-content: space-between; */

	padding: 16px;
	border-radius: 8px;
	margin-bottom: 32px;

	background-color: rgb(245, 245, 245);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.0);
	backface-visibility: hidden;
	-webkit-backface-visibility: hidden;

	cursor: pointer;

	transition: 0.2s;
}

.tile:hover {
	background-color: rgb(240, 239, 239);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.tile:active {
	background-color: rgb(228, 228, 228);
	box-shadow: 0 1px 4px rgba(0, 0, 0, 0.25);
}

.tile img {
	order: 0;
	width: 180px;
}

.tile .text-container_ {
	order: 1;
	flex-grow: 100;
	padding-left: 24px;
}

.tile .text-container_ .text {
	position: relative;
	top: 50%;
	transform: translateY(-50%);
	text-align: left;
}

.tile .icon-container_ {
	order: 2;
}

.tile .icon-container_ .icon {
	height: 100%;
	padding-left: 8px;
	transform: translateX(8px) scale(0.8);
	opacity: 0.0;
}

.tile:hover .icon-container_ .icon {
	transform: translateX(0px) scale(1.0);
	opacity: 1.0;
}

@media screen and (max-width: 599px) {
	.tile {
		flex-direction: column;
	}

	.tile img {
		height: 100%;
		width: 100%;
	}

	.tile .text-container_ .text {
		transform: translateY(0);
	}

	.tile .icon-container_ .icon {
		right: 0;
	}
}

.tile .text .device-title {
	font-weight: 700;
	font-size: 16px;
	padding-bottom: 8px;
}

@media screen and (min-width: 600px) {
	.tile .haqcs-height {
		height: 153px;
	}

	.tile .marley-haqcs-edition-height {
		height: 69px;
	}

	.tile .upgrade-marley-menv-180-height {
		height: 119px;
	}

	.tile .upgrade-prana-150-200-height {
		height: 120px;
	}

	.tile .unibox-height {
		height: 305px;
	}
}

.table-container_ {
	margin-bottom: 32px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.25);
}

.table-container_ .table {
	display: flex;
	padding: 4px;
}

@media screen and (max-width: 500px) {
	.table-container_ .table {
		flex-direction: column;
	}
}

.table-container_ .table-even {
	background-color: rgb(248, 248, 248);
}

.table-container_ .table-uneven {
	background-color: rgb(241, 241, 241);
}

.table-container_ .table .parameter {
	order: 0;
	width: 180px;
	border-color: black;
	font-weight: bold;
	padding-left: 4px;
}

.table-container_ .table .value {
	order: 1;
	flex-shrink: 100;
	padding-left: 4px;
	padding-right: 4px;
}

ul {
	margin-top: 8px;
	padding-bottom: 16px;
}

ol {
	margin-top: 8px;
	padding-bottom: 16px;
}

li {
	padding-bottom: 8px;
}

.narrow {
	padding-bottom: 0;
}

.narrow li {
	padding-bottom: 0;
}

.p-p {
	/* text-align: justify; */
	text-align: left;
}

.p-img {
	display: block;
	margin-left: auto;
	margin-right: auto;
	margin-top: 8px;
	margin-bottom: 32px;
	box-shadow: 0 2px 4px rgb(0, 0, 0, 0.38);
	max-width: 100%;
	max-height: 100%;
}

.no-shadow {
	box-shadow: 0 0 0 rgb(0, 0, 0, 0);
}

.link {
	cursor: pointer;
	color:rgb(11, 112, 180);
}

.link:hover {
	color:rgb(8, 87, 139);
	text-decoration: underline;
}

.message {
	margin: 12px 5%;
	text-align: left;
}

.between-headings {
	margin-top:-32px;
}

.article-date {
	font-size: 0.9rem;
	font-weight: 500;
	color: rgb(128, 128, 128);
}

::selection {
	background: #A7F7A6;
}
</style>



// WEBPACK FOOTER //
// Dokumentation.vue?51d56b83